"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var ClassificationRowData_1 = tslib_1.__importDefault(require("./ClassificationRowData"));
var ClassificationTableHeader_1 = tslib_1.__importDefault(require("./ClassificationTableHeader"));
var columns = [
    {
        title: 'Classifications',
        staticTitle: true,
        style: {
            borderBottom: '1px solid black',
            borderLeft: 'none',
            fontSize: '12px',
            padding: '0 9px 4px 9px',
            textAlign: 'left',
            width: '20%',
        },
    },
    {
        title: 'Long',
        staticTitle: false,
    },
    {
        title: 'Short',
        staticTitle: false,
    },
    {
        title: 'Gross',
        staticTitle: false,
    },
    {
        title: 'Net',
        staticTitle: false,
        colSpan: 2,
    },
    {
        title: undefined,
        style: { width: '50%', borderLeft: 'none' },
        staticTitle: true,
    },
];
var ClassificationTable = function (_a) {
    var isEditing = _a.isEditing, isSubmitting = _a.isSubmitting, classifications = _a.classifications, classificationDetails = _a.classificationDetails, asOfDate = _a.asOfDate, tableHeaderText = _a.tableHeaderText, entryMode = _a.entryMode, isDataEdited = _a.isDataEdited, setIsDataEdited = _a.setIsDataEdited, selectedAsOfDate = _a.selectedAsOfDate, onBlurGridData = _a.onBlurGridData, setEditedClassificationValues = _a.setEditedClassificationValues, previousDateGridData = _a.previousDateGridData;
    return (react_1.default.createElement(StyledClassificationContentTable, null,
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(ClassificationTableHeader_1.default, { columns: columns, tableHeaderText: tableHeaderText, entryMode: entryMode }),
                react_1.default.createElement(ClassificationRowData_1.default, { classificationDetails: classificationDetails, selectedAsOfDate: selectedAsOfDate, classifications: classifications, isEditing: isEditing, isSubmitting: isSubmitting, isDataEdited: isDataEdited, setIsDataEdited: function (value) {
                        return setIsDataEdited ? setIsDataEdited(value) : null;
                    }, onBlurGridData: onBlurGridData, setEditedClassificationValues: setEditedClassificationValues, previousDateGridData: previousDateGridData })))));
};
exports.default = ClassificationTable;
var StyledClassificationContentTable = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-top: 10px;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n"], ["\n  margin-top: 10px;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1;
